import { render, staticRenderFns } from "./ToolSettings.vue?vue&type=template&id=a3164f94&scoped=true"
import script from "./ToolSettings.vue?vue&type=script&lang=js"
export * from "./ToolSettings.vue?vue&type=script&lang=js"
import style0 from "./ToolSettings.vue?vue&type=style&index=0&id=a3164f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3164f94",
  null
  
)

export default component.exports